import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/toaster';
import AuthPage from '@/pages/AuthPage';
import SSOCallbackPage from '@/pages/SSOCallbackPage';
import Activate from '@/pages/Activate';

/**
 * CNVRGNX Identity Module - Main Application
 * 
 * This is the standalone identity module that handles:
 * - User authentication (login/signup)
 * - SSO/SAML/OIDC flows
 * - Password reset
 * - MFA setup and verification
 * 
 * Deployed to: login.cnvrgnx.com (production), login-dev.cnvrgnx.com (development)
 */
function App() {
  return (
    <>
      <Routes>
        {/* Main auth page */}
        <Route path="/" element={<AuthPage />} />
        <Route path="/auth" element={<AuthPage />} />
        
        {/* Password reset links come to this route */}
        <Route path="/accounts/signin" element={<AuthPage />} />
        
        {/* Account activation links */}
        <Route path="/activate" element={<Activate />} />
        
        {/* SSO callback routes - handles post-IdP redirect */}
        <Route path="/accounts/sso-callback" element={<SSOCallbackPage />} />
        <Route path="/auth/callback" element={<AuthPage />} />
        <Route path="/sso/callback" element={<AuthPage />} />
        
        {/* Password reset */}
        <Route path="/reset-password" element={<AuthPage />} />
        
        {/* Catch-all redirect to auth */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster />
    </>
  );
}

export default App;
